import { PublicSiteApi, WebApiCustomListsDtoCreateCustomListItemDto, WebApiCustomListsDtoCustomListItemDto, WebApiCustomListsDtoUpdateCustomListItemDto, WebApiMemberDtoAddMemberFromPublicSiteDto, WebApiMemberDtoCreatePasswordCodeDto, WebApiModelsCustomListField, WebApiPublicSiteDtoAddOwnFamilyMemberDto, WebApiPublicSiteDtoEditableCustomListDto, WebApiPublicSiteDtoLoginWithPasswordCodeDto, WebApiPublicSiteDtoUpdateFamilyMemberSelfDto, WebApiPublicSiteDtoUpdateOwnFamilyMemberDto, WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode, WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto, WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto, } from "../Repository/eventbookyapi";
import { GetApiConfigurationMember } from "./ServiceConfiguration";

export abstract class PublicSiteService {

    public static Logout = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteLogoutPost();
    };

    public static CreatePasswordCode = async (request: WebApiMemberDtoCreatePasswordCodeDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCreatePasswordCodePost({
            webApiMemberDtoCreatePasswordCodeDto: request
        });
    };

    public static LoginWithPasswordCode = async (request: WebApiPublicSiteDtoLoginWithPasswordCodeDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteLoginWithPasswordCodePost({
            webApiPublicSiteDtoLoginWithPasswordCodeDto: request
        });
    };

    public static GetMember = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetMemberGet();
    };

    public static UpdateMember = async (request: WebApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteUpdateMemberPost({
            webApiServicesDataTransferObjectsGroupServiceUpdatePublicMemberDto: request
        });
    };

    // Which self-edit page to render for the logged-in member (regular vs. family).
    public static GetSession = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetSessionGet();
    };

    public static GetFamilyMemberSelf = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetFamilyMemberSelfGet();
    };

    public static UpdateFamilyMemberSelf = async (request: WebApiPublicSiteDtoUpdateFamilyMemberSelfDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteUpdateFamilyMemberSelfPost({
            webApiPublicSiteDtoUpdateFamilyMemberSelfDto: request
        });
    };

    public static GetMyFamilyMembers = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetMyFamilyMembersGet();
    };

    public static AddMyFamilyMember = async (request: WebApiPublicSiteDtoAddOwnFamilyMemberDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteAddMyFamilyMemberPost({
            webApiPublicSiteDtoAddOwnFamilyMemberDto: request
        });
    };

    public static UpdateMyFamilyMember = async (request: WebApiPublicSiteDtoUpdateOwnFamilyMemberDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteUpdateMyFamilyMemberPost({
            webApiPublicSiteDtoUpdateOwnFamilyMemberDto: request
        });
    };

    public static DeleteMyFamilyMember = async (memberId: number) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteDeleteMyFamilyMemberPost({
            memberId: memberId
        });
    };

    public static AddmemberByMember = async (request: WebApiMemberDtoAddMemberFromPublicSiteDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteAddMemberFromPublicSitePost({
            webApiMemberDtoAddMemberFromPublicSiteDto: request
        });
    };

    public static GetMemberFieldsByUrl = async (url: string) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetMemberFieldsPublicSiteByUrlGet({ url });
    };

    public static GetMembershipProductsByUrl = async (url: string) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetMembershipProductsFromPublicSiteByUrlGet({ url });
    };


    public static ActiveMemberAccount = async (request: WebApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteActivateAccountFromPublicSitePost({
            webApiServicesDataTransferObjectsGroupServiceActiveUserByPasswordCode: request
        });
    };

    public static ConfirmEmailChange = async (request: WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteConfirmEmailChangePost({
            webApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto: request
        });
    };

    public static GetCompanyPublicSiteByUrl = async (url: string) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetCompanyPublicSiteByUrlGet({ url: url });
    };

    public static HasPublicMemberView = async (url: string) => {
        const result = await new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteHasPublicMemberViewGet({ url });
        // API returns string "true"/"false" instead of boolean
        return result === true || (result as any) === 'true';
    };

    public static GetPublicMemberView = async (url: string) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteGetPublicMemberViewGet({ url });
    };

    public static GetEditableCustomLists = async () => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteEditableCustomListsGet();
    };

    public static GetEditableCustomListItems = async (customListId: number) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCustomListItemsCustomListIdGet({ customListId });
    };

    // All items in a list, for lookup/dropdown fields that reference another list - only works
    // for lists flagged member-visible (MembersEditRights.OwnItems) server-side.
    public static GetCustomListItemsForLookup = async (customListId: number) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCustomListItemsCustomListIdLookupGet({ customListId });
    };

    public static CreateEditableCustomListItem = async (customListId: number, dto: WebApiCustomListsDtoCreateCustomListItemDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCustomListItemsCustomListIdPost({
            customListId,
            webApiCustomListsDtoCreateCustomListItemDto: dto
        });
    };

    public static UpdateEditableCustomListItem = async (customListId: number, id: number, dto: WebApiCustomListsDtoUpdateCustomListItemDto) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCustomListItemsCustomListIdIdPost({
            customListId,
            id,
            webApiCustomListsDtoUpdateCustomListItemDto: dto
        });
    };

    public static DeleteEditableCustomListItem = async (customListId: number, id: number) => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteCustomListItemsCustomListIdIdDelete({
            customListId,
            id
        });
    };

    public static GetEditableCustomListFields = async (customListId: number): Promise<WebApiModelsCustomListField[]> => {
        return new PublicSiteApi(GetApiConfigurationMember()).apiPublicSiteEditableCustomListsCustomListIdFieldsGet({ customListId });
    };
};
